export const GA_EVENTS = {
    EW_POPUP_OPEN: {
        event: "ew_pop_up_clicked",
        eventCategory: "ew_top_funnel"
    }
};
